import React from "react";
import logoWhite from "../assets/logo-white-on-dark.jpg";
import "../styles/LoadingScreen.css";

// Tela de carregamento cheia (dark + logo) — substitui o "Carregando..."
// sobre fundo branco que vazava do app antigo em toda transição/refresh.
const LoadingScreen = () => (
  <div className="loading-screen">
    <img src={logoWhite} alt="Iron House" className="loading-screen-logo" />
    <div className="loading-screen-spinner" />
  </div>
);

export default LoadingScreen;
